module.exports = __webpack_public_path__ + "img/5f666f1.jpg";